import { render, staticRenderFns } from "./SubscribePlan.vue?vue&type=template&id=90459a80&scoped=true"
import script from "./SubscribePlan.vue?vue&type=script&lang=js"
export * from "./SubscribePlan.vue?vue&type=script&lang=js"
import style0 from "./SubscribePlan.vue?vue&type=style&index=0&id=90459a80&prod&lang=scss"
import style1 from "./SubscribePlan.vue?vue&type=style&index=1&id=90459a80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90459a80",
  null
  
)

export default component.exports